import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class VisionStepKeyValue extends BasicEntity {
exclude: boolean | null;
include: boolean | null;
key: string;
visionCode: string;
visionStepCode: string;
}

